import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateHelper {
    static readonly FRENCH_DATE_FORMAT = 'dd/MM/YYYY';
    static readonly FRENCH_DATETIME_FORMAT = 'dd/MM/yyyy HH:mm:ss';
    static readonly FRENCH_DATETIME_WITHOUT_SECONDS_FORMAT = 'dd/MM/yyyy HH:mm';
    static readonly ISO_8601_DATE_FORMAT: string = 'yyyy-MM-dd';
    static readonly ISO_8601_DATETIME_FORMAT: string = 'yyyy-MM-ddTHH:mm:ss.SSS';
    /**
     * Constructeur.
     * @param datePipe : Pipe 'Date' utilisé pour formatter les dates.
     */
    constructor(protected datePipe: DatePipe) {}

    /**
     * Formatte la date specifiée au format français (dd/MM/YYYY).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public formatAsFrenchDate(date: Date): string {
        return this.datePipe.transform(date, DateHelper.FRENCH_DATE_FORMAT);
    }

    /**
     * Formatte la date specifiée au format français (dd/MM/YYYY).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public formatAsFrenchDateTime(date: Date): string {
        return this.datePipe.transform(date, DateHelper.FRENCH_DATETIME_FORMAT);
    }

    /**
     * Formatte la date specifiée au format ISO-8601 (yyyy-MM-dd).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public formatAsIso8601Date(date: Date): string {
        return this.datePipe.transform(date, DateHelper.ISO_8601_DATE_FORMAT);
    }

    /**
     * Formatte la date specifiée au format ISO-8601 avec heure (yyyy-MM-ddTHH:mm:ss.SSS).
     * @param date : La date à formatter.
     * @returns : La date formattée.
     */
    public formatAsIso8601DateTime(date: Date): string {
        return this.datePipe.transform(date, DateHelper.ISO_8601_DATETIME_FORMAT);
    }
}
